export const Footer = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const navLinks = [
    { label: "About", id: "about" },
    { label: "Services", id: "services" },
    { label: "Approach", id: "approach" },
    { label: "Contact", id: "contact" },
  ];

  return (
    <footer
      data-testid="footer"
      className="py-16 md:py-20 border-t"
      style={{
        background: "var(--bg-primary)",
        borderColor: "var(--border)",
      }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Top row: Logo, Nav, Contact */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
          {/* Logo */}
          <div>
            <span
              className="tracking-[0.25em] text-lg"
              style={{
                fontFamily: "var(--font-serif)",
                fontWeight: 600,
                color: "var(--text-primary)",
              }}
            >
              VALTOR CAPITAL
            </span>
            <p
              className="mt-4 text-sm"
              style={{
                fontFamily: "var(--font-sans)",
                fontWeight: 300,
                color: "var(--text-muted)",
                lineHeight: 1.7,
              }}
            >
              Where Capital Meets Conviction
            </p>
          </div>

          {/* Nav links */}
          <div className="flex flex-col gap-3">
            {navLinks.map((link) => (
              <button
                key={link.id}
                data-testid={`footer-link-${link.id}`}
                onClick={() => scrollTo(link.id)}
                className="footer-link bg-transparent border-none cursor-pointer p-0 text-left w-fit"
              >
                {link.label}
              </button>
            ))}
          </div>

          {/* Contact info */}
          <div className="flex flex-col gap-2">
            <span
              className="text-sm"
              style={{
                fontFamily: "var(--font-sans)",
                fontWeight: 300,
                color: "var(--text-muted)",
              }}
            >
              20 Lexington Drive, Bella Vista NSW 2153
            </span>
            <span
              className="text-sm"
              style={{
                fontFamily: "var(--font-sans)",
                fontWeight: 300,
                color: "var(--text-muted)",
              }}
            >
              info@valcap.com.au
            </span>
            <span
              className="text-sm"
              style={{
                fontFamily: "var(--font-sans)",
                fontWeight: 300,
                color: "var(--text-muted)",
              }}
            >
              +61 402 266 884
            </span>
          </div>
        </div>

        {/* Divider */}
        <div
          className="w-full h-px mb-8"
          style={{ background: "var(--border)" }}
        />

        {/* Bottom row */}
        <div className="flex flex-col md:flex-row justify-between gap-6">
          <div className="flex flex-col gap-2">
            <p
              className="text-xs"
              style={{
                fontFamily: "var(--font-sans)",
                fontWeight: 400,
                color: "var(--text-muted)",
                letterSpacing: "0.02em",
              }}
            >
              Valtor Capital Pty Ltd | ABN 59 680 710 650
            </p>
            <p
              className="text-xs"
              style={{
                fontFamily: "var(--font-sans)",
                fontWeight: 300,
                color: "var(--text-muted)",
              }}
            >
              Registered Address: 20 Lexington Drive, Bella Vista NSW 2153
            </p>
          </div>
          <p
            className="text-xs"
            style={{
              fontFamily: "var(--font-sans)",
              fontWeight: 300,
              color: "var(--text-muted)",
            }}
          >
            &copy; 2025 Valtor Capital Pty Ltd. All rights reserved.
          </p>
        </div>

        {/* Legal disclaimer */}
        <p
          className="mt-6 text-xs leading-relaxed max-w-4xl"
          style={{
            fontFamily: "var(--font-sans)",
            fontWeight: 300,
            color: "rgba(90, 90, 90, 0.7)",
            lineHeight: 1.7,
          }}
        >
          This website is for general informational purposes only and does not
          constitute financial, investment, or legal advice. Valtor Capital Pty
          Ltd operates as a property advisory firm and is not a licensed
          financial product advisor.
        </p>
      </div>
    </footer>
  );
};
